/** @type {{ name: string, neighborhoods: string[] | null }[]} */
window.KAYSERI_DELIVERY_AREAS = [
  {
    name: 'Melikgazi',
    neighborhoods: [
      'AALPARSLAN',
      'ALTINOLUK',
      'ANAFARTALAR',
      'ANBAR + 150 TL Uzun Mesafe Ücreti',
      'AYDINLIK EVLER',
      'BATTALGAZİ MH',
      'BECEN MH. + 150 TL Uzun Mesafe Ücreti',
      'BELSİN',
      'BEŞPARMAK',
      'CAFERBEY',
      'CUMHURİYET MH-(çarşı)',
      'DANİŞMENT GAZİ',
      'ERCİYES DAĞI + 1000 TL Uzun Mesafe Ücreti',
      'ERENKÖY-TALAS',
      'ESENTEPE',
      'ESENYURT',
      'EĞRİBUCAK',
      'FATİH-KOCASİNAN',
      'GAZİ OSMAN',
      'GERMİR MH. + 100 TL Uzun Mesafe Ücreti',
      'GESİ CUMHURİYET MH. + 250 TL Uzun Mesafe Ücreti',
      'GESİ FATİH MH. + 250 TL Uzun Mesafe Ücreti',
      'GÖKKENT + 250 TL Uzun Mesafe Ücreti',
      'GÜLTEPE',
      'GÜLÜK MH.',
      'HUNAT',
      'HÜRRİYET MH',
      'HİSARCIK MH + 300 TL Uzun Mesafe Ücreti',
      'KARACAOĞLU MH.',
      'KAZIM KARABEKİR',
      'KEMERALTI',
      'KEYKUBAT',
      'KILIÇASLAN MH',
      'KIRANARDI + 400 TL Uzun Mesafe Ücreti',
      'KOCATEPE',
      'KÖŞK MH',
      'KÜÇÜK MUSTAFA',
      'KÜÇÜKALİ',
      'KİÇİKAPI',
      'MELİKGAZİ',
      'MERKEZ',
      'MOBİLYACILAR SİTESİ + 200 TL Uzun Mesafe Ücreti',
      'MİM-SİN-MİMARSİNAN + 250 TL Uzun Mesafe Ücreti',
      'MİMARSİNAN BAHÇELİEVLER MH + 250 TL Uzun Mesafe Ücreti',
      'MİMARSİNAN DEMOKRASİ MAH. + 250 TL Uzun Mesafe Ücreti',
      'MİMARSİNAN DERE MAH. + 250 TL Uzun Mesafe Ücreti',
      'MİMARSİNAN FATİH MH. + 250 TL Uzun Mesafe Ücreti',
      'MİMARSİNAN O.S.B + 500 TL Uzun Mesafe Ücreti',
      'MİMARSİNAN ŞİRİNTEPE MH + 250 TL Uzun Mesafe Ücreti',
      'NURİ HAS MH.',
      'O.S.B. ORGANİZE SANAYİ + 200 TL Uzun Mesafe Ücreti',
      'Ondokuz Mayıs Mh + 150 TL Uzun Mesafe Ücreti',
      'OSMAN KAVUNCU',
      'OSMANLI MH',
      'Otuz Ağustos mh + 200 TL Uzun Mesafe Ücreti',
      'PLEVNE MH',
      'SAKARYA MH.',
      'SELÇUKLU MH',
      'SELİMİYE',
      'SERKENT + 250 TL Uzun Mesafe Ücreti',
      'SERÇEÖNÜ',
      'SEYİD GAZİ',
      'TACETTİN VELİ',
      'TAVLUSUN + 150 TL Uzun Mesafe Ücreti',
      'TINAZTEPE + 200 TL Uzun Mesafe Ücreti',
      'TOKİ DEMOKRASİ MH + 250 TL Uzun Mesafe Ücreti',
      'YENİ KÖY MH',
      'YENİ PERVANE',
      'YEŞİLYURT MH. + 450 TL Uzun Mesafe Ücreti',
      'YILDIRIM BEYAZIT',
      'ÇORAKÇILAR',
      'İLDEM + 250 TL Uzun Mesafe Ücreti',
      'İLDEM BEYAZŞEHİR + 250 TL Uzun Mesafe Ücreti',
      'ŞEHİR HASTANESİ + 150 TL Uzun Mesafe Ücreti',
      'ŞİRİNEVLER',
    ],
  },
  {
    name: 'Kocasinan',
    neighborhoods: [
      'AHİ EVRAN MH. + 200 TL Uzun Mesafe Ücreti',
      'ALSANCAK',
      'ARGINCIK',
      'BARBAROS MH',
      'BEYAZŞEHİR + 250 TL Uzun Mesafe Ücreti',
      'BOZTEPE',
      'BUĞDAYLI + 300 TL Uzun Mesafe Ücreti',
      'CIRGALAN BEYAZŞEHİR + 250 TL Uzun Mesafe Ücreti',
      'ERCİYES EVLER',
      'ERCİYES ÜNİVERSİTESİ',
      'ERKİLET',
      'ERKİLET CAMİKEBİR MAH.',
      'ERKİLET DERE MAH.',
      'ERKİLET ERTUĞRUL GAZİ',
      'ERKİLET GENERAL EMİR + 200 TL Uzun Mesafe Ücreti',
      'ERKİLET OSMANGAZİ MAH.',
      'ESKİŞEHİR BAĞLARI',
      'FEVZİ ÇAKMAK',
      'FEVZİOĞLU + 100 TL Uzun Mesafe Ücreti',
      'FİNAL OKULLARI + 100 TL Uzun Mesafe Ücreti',
      'GEVHER NESİBE',
      'HACI SAKİ MH.',
      'HOCA AHMET YESEVİ',
      'HİLAL',
      'KAY-KOOP + 200 TL Uzun Mesafe Ücreti',
      'Kocasinan',
      'MİMARSİNAN MH (kocasinan)',
      'MİTHAT PAŞA',
      'OYMAAĞAÇ MH. + 200 TL Uzun Mesafe Ücreti',
      'SAHABİYE',
      'SANAYİ MH',
      'SANCAKTEPE',
      'SÜMER',
      'TALATPAŞA MH',
      'TURGUT REİS',
      'UĞUR EVLER',
      'YAKUT MAH.',
      'YAVUZ SELİM MH. + 200 TL Uzun Mesafe Ücreti',
      'YAVUZLAR',
      'Yenidoğan-kocasinan',
      'YENİ MH',
      'YENİ SANAYİ',
      'YENİŞEHİR',
      'YEŞİL MH',
      'YILDIZ EVLER',
      'YUNUS EMRE',
      'ZÜMRÜT MH.',
      'ZİYA GÖKALP',
      'ÖRNEK EVLER',
      'ŞEKER + 200 TL Uzun Mesafe Ücreti',
      'ŞEKER TOKİ + 200 TL Uzun Mesafe Ücreti',
    ],
  },
  {
    name: 'Talas',
    neighborhoods: [
      'ANAYURT-TALAS',
      'BAHÇELİEVLER-TALAS',
      'BAŞAKPINAR + 800 TL Uzun Mesafe Ücreti',
      'ENDÜRLÜK + 200 TL Uzun Mesafe Ücreti',
      'HARMAN-TALAS',
      'KOMANDO CAD.YUKARI TALAS + 100 TL Uzun Mesafe Ücreti',
      'KONAKLAR + 150 TL Uzun Mesafe Ücreti',
      'KUMSMALL AVM + 200 TL Uzun Mesafe Ücreti',
      'KİÇİKÖY-TALAS',
      'MEVLANA-TALAS',
      'NUH NACİ YAZGAN ÜNİVERSİTESİ + 200 TL Uzun Mesafe Ücreti',
      'REŞADİYE + 400 TL Uzun Mesafe Ücreti',
      'TALAS',
      'YENİDOĞAN-TALAS',
    ],
  },
  {
    name: 'Develi',
    neighborhoods: [
      'DEVELİ + 800 TL Uzun Mesafe Ücreti',
    ],
  },
  {
    name: 'Hacılar',
    neighborhoods: [
      'HACILAR + 250 TL Uzun Mesafe Ücreti',
    ],
  },
  {
    name: 'İncesu',
    neighborhoods: [
      'İNCESU + 600 TL Uzun Mesafe Ücreti',
    ],
  },
];
